export const MOBILE_BREAKPOINT = 767;
export const TABLET_BREAKPOINT = 991;
